const getUrlWithoutQueryParams = url => url.split('?')[0];

export default getUrlWithoutQueryParams;
